/**
 * ErrorBoundary genérico para aislar secciones del UI de crashes totales.
 * v4.4.21 — captura errores en render/lifecycle y muestra un mensaje
 * útil en vez del pantallazo negro.
 *
 * Uso:
 *   <ErrorBoundary label="Post-Mortem">
 *     <ComponenteQuePuedeFallar />
 *   </ErrorBoundary>
 */
import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary ${this.props.label || ""}]`, error, errorInfo);
    this.setState({ errorInfo });
  }

  reset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="p-4 bg-red-500/10 border border-red-400/30 rounded-lg">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-red-300 mb-1">
              Error al cargar {this.props.label || "esta sección"}
            </div>
            <div className="text-xs text-red-200/80 font-mono break-words">
              {this.state.error?.message || String(this.state.error)}
            </div>
            <button
              onClick={this.reset}
              className="mt-2 flex items-center gap-1 text-xs text-red-300 hover:text-red-200"
            >
              <RefreshCw className="w-3 h-3" />
              Reintentar
            </button>
          </div>
        </div>
      </div>
    );
  }
}
